import { PREFIX } from '../constants/actions';
import { makeAlertReducers, makeAlertSelectors } from '../../../ui-lottery/src/reducers/alerts';

export const { alerts } = makeAlertReducers(PREFIX);
export const selectors = makeAlertSelectors('portal');
